import { FilterProps } from "../filter-definition";
import { RadioButtonDateFilter } from "../GenericFilters/RadioButtonDateFilter";
import ordersDefaultFilters from "./orders-default-filters";

export const OrdersCreateDateFilter = (props: FilterProps) => (
  <RadioButtonDateFilter
    {...props}
    filterKey="createDate"
    name="Create Date"
    defaultFilterType={ordersDefaultFilters.createDateType}
    defaultStartDate={ordersDefaultFilters.createDateStartDate}
    defaultEndDate={ordersDefaultFilters.createDateEndDate}
  />
);
